import { useCallback } from 'react';
import type {
	ChildResult,
	CommandSections,
} from '@atlassian/jira-command-palette/src/common/types/commands/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { QUICK_SEARCH_PRIORITY } from '../../../../../common/ui/constants';
import { useGetQuickSearchIssueCommands } from '../../../../../common/ui/issue';
import type {
	GetQuickSearchChildResultProps,
	UseGetChildResult,
} from '../../../../../common/ui/types';
import { messages } from './messages';

const SECTION_ID = 'jira.issue';

export const useGetRecentIssuesChildResult: UseGetChildResult = () => {
	const { formatMessage } = useIntl();

	const { getQuickSearchIssueCommands } = useGetQuickSearchIssueCommands({
		section: SECTION_ID,
		errorMessage: formatMessage(messages.issueError),
		showViewAll: false,
	});
	const getChildResult = useCallback(
		(props: GetQuickSearchChildResultProps): ChildResult => {
			const sections: CommandSections = {
				[SECTION_ID]: {
					id: SECTION_ID,
					name: formatMessage(messages.recentlyViewedIssues),
					priority: QUICK_SEARCH_PRIORITY.ISSUES,
				},
			};

			const commands = getQuickSearchIssueCommands(props);

			return {
				sections,
				commands,
			};
		},
		[formatMessage, getQuickSearchIssueCommands],
	);

	return { getChildResult };
};
